import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import Map, { MapRef, Marker } from 'devextreme-react/map';
import { mapConfiguration } from '../../mapConfig';
import * as atlas from 'azure-maps-control';


type Props = {
  latitudine?: number;
  longitudine?: number;
  address?: string;
  onCoordinateChange?: (latitudine: number, longitudine: number) => void;
}

export type PositionEditPanelHandle = {
}

const PositionEditPanel: React.ForwardRefRenderFunction<PositionEditPanelHandle, Props> = (props, ref) => {
  const mapRef = useRef<atlas.Map>();
  const markerRef = useRef<atlas.HtmlMarker>();

  const handleReady = async (e: any) => {
    mapRef.current = e.originalMap as atlas.Map;

    const marker = await getMarkerRef();
    if (marker) {
      mapRef.current.setCamera({ center: marker.getOptions().position, zoom: 14 });
    }
  };

  async function getMarkerRef() {
    if (!mapRef.current) return null;

    if (markerRef.current) return markerRef.current;
 
    var { latitudine, longitudine } = props;
   
    if (latitudine === 0 || longitudine === 0 || !latitudine || !longitudine) {
      //   console.warn("Latitudine o longitudine non valide, si sta cercando di geocodificare l'indirizzo");
      //   // Geocode address if lat/lon are not provided
      var pos = await geocodeAddress(props.address || ''); //.then((pos) => {
      if (pos) {
        latitudine = pos[1]; // [lat, lon]
        longitudine = pos[0]; // [lat, lon]
        props.onCoordinateChange?.(pos[1], pos[0]);
      }
    };

    if (!latitudine || !longitudine) return;

    const marker = new atlas.HtmlMarker({
      draggable: true,
      position: [longitudine, latitudine],
    });

    mapRef.current.markers.add(marker);
    markerRef.current = marker;

    mapRef.current.events.add('dragend', marker, () => {
      const pos = marker.getOptions().position;
      if (pos)
        props.onCoordinateChange?.(pos[1], pos[0]); // [lat, lon]
    });

    return markerRef.current;
  }

  useEffect(() => {
    if (markerRef.current && props.latitudine && props.longitudine) {

      if (props.latitudine == 0 || props.longitudine == 0) {
        console.warn("Latitudine o longitudine non valide, si sta cercando di geocodificare l'indirizzo");

        //geocodeAddress()
      }
      else
        markerRef.current.setOptions({
          position: [props.longitudine, props.latitudine],
        });
    }
  }, [props.latitudine, props.longitudine]);

  async function geocodeAddress(address: string): Promise<[number, number] | null> {
    const subscriptionKey = mapConfiguration.azure;
    console.log("Geocoding address:", address); 
    const encodedAddress = encodeURIComponent(address);
    const url = `https://atlas.microsoft.com/search/address/json?api-version=1.0&subscription-key=${subscriptionKey}&query=${encodedAddress}`;

    const response = await fetch(url);
    const data = await response.json();

    if (data.results && data.results.length > 0) {
      const { lat, lon } = data.results[0].position;
      return [lon, lat]; // 💡 formato [longitudine, latitudine]
    }

    return null;
  }

  return (
    <Map
      defaultZoom={14}
      height="calc(100vh - 110px)"
      width="100%"
      provider="azure"
      type="hybrid"
      apiKey={mapConfiguration}
      autoAdjust={true}
      onReady={handleReady}
    />
  );
};



export default React.forwardRef(PositionEditPanel);